import { create } from 'zustand';
import { fetchWithAuth } from '@/services/api';

export interface AppUser {
  id: string;
  auth_user_id?: string | null;
  tenant_id?: string | null;
  loja_id?: string | null;
  nome: string;
  email: string;
  role: 'super_admin' | 'tenant_admin' | 'gestor' | 'vendedor';
  avatar_url?: string | null;
  telefone?: string | null;
  ativo: boolean;
  created_at?: string;
  updated_at?: string;
}

interface UsersState {
  users: AppUser[];
  loading: boolean;
  fetched: boolean;
  fetchUsers: (force?: boolean) => Promise<void>;
  getById: (id: string | null | undefined) => AppUser | undefined;
}

export const useUsersStore = create<UsersState>()((set, get) => ({
  users: [],
  loading: false,
  fetched: false,

  fetchUsers: async (force = false) => {
    if (get().fetched && !force) return;
    set({ loading: true });

    try {
      const res = await fetchWithAuth('/api/tenant/users?all=true');
      if (res.ok) {
        const data = await res.json();
        set({ users: Array.isArray(data) ? data : [], fetched: true });
      } else {
        console.error('[USERS_STORE] fetchUsers API error status:', res.status);
        set({ users: [] });
      }
    } catch (err) {
      console.error('[USERS_STORE] Exception:', err);
      set({ users: [] });
    } finally {
      set({ loading: false, fetched: true });
    }
  },

  getById: (id) => {
    if (!id) return undefined;
    return get().users.find(u => u.id === id);
  }
}));
